import CommonOptionsMixin from '@/components/mixins/common-options-mixin'
import FontList from '@/components/common/font-list/font-list-tmpl'
import MediaList from '@/components/common/media-list/media-list-tmpl'
import TagsMenuItem from '@/components/common/tags/tags-tmpl'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'

export default {
  name: 'editPprojectTemplateMenu',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: { FontList, MediaList, TagsMenuItem },
  props: {
    projectTemplateProp: {
      type: Object,
      default () { return {} }
    },
    editTemplateFrameTabProp: {
      type: String,
      default () { return '' }
    },
    tagsSummaryForSuggestionsProp: {
      type: Array,
      default () { return [] }
    }
  },
  watch: {
    projectActionProp (newVal) {
      this.projectAction = newVal
    },
    projectTemplateProp (newVal) {
      this.setDefaultData(newVal)
    },
    editTemplateFrameTabProp (newVal) {
      this.selectedEditFrameTab = newVal
      this.$nextTick(() => { this.handleRadioElConstantWidth() }) // Adjust Radio button width
    },
    tagsSummaryForSuggestionsProp: {
      handler (newVal) {
        this.tagsSummaryForSuggestions = newVal
      },
      deep: true
    }
  },
  mixins: [CommonOptionsMixin, UnsavedDataMixin],
  data () {
    return {
      error: '',
      selectedEditFrameTab: this.editTemplateFrameTabProp,
      editableOptionProperties: ['tags'],
      editedOptionProperties: [],
      menuItems: [{
        id: 'name',
        name: this.$t('label.name'),
        value: null,
        type: 'name',
        editable: false
      },
      {
        id: 'tags',
        name: this.$t('label.tag', 2),
        value: null,
        type: 'tags',
        editable: true
      }],
      menuData: {
        name: null,
        tags: []
      },
      projectAction: this.projectActionProp,
      projectTemplate: this.projectTemplateProp,
      tagsSummaryForSuggestions: this.tagsSummaryForSuggestionsProp,
      showTagsMenuItem: this.$currentUser.hasGroupExtended()
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('project-audio-menu-change', { action, payload: { data } })
      }
    },
    setDefaultData (projectData) {
      if (projectData.tags) { this.menuData.tags = projectData.tags }
      this.menuData.name = projectData.name
    },
    /**
     * Handle Menu Item Element onChange
     */
    handleMenuItemChange (event, type, name) {
      // Set Unsaved Changes
      if (name === 'tags') {
        this.menuData.tags = event.payload.data.tags
        this.emitEvent('TAGS_CHANGED', this.menuData.tags)
      }

      if (name === 'name') {
        this.emitEvent('NAME_CHANGED', this.menuData.name)

        if (this.editableOptionProperties.indexOf('name') >= 0) {
          this.editableOptionProperties = this.editableOptionProperties.filter((item) => { return item !== 'name' })
          this.menuItems = this.filterOptionProperties(this.menuItems, false)
        }
      }
      this.setUnsavedDataFlagIntoLocalstorage({ page: 'editProject' })
    },
    filterOptionProperties (menuItemsSrc, resetSelected) {
      const menuItems = this.$utils.clone(menuItemsSrc)
      const editableOptionProperties = this.editableOptionProperties

      for (const i in menuItems) {
        const optionProp = menuItems[i]
        optionProp.editable = false

        if ((editableOptionProperties.indexOf(optionProp.id) >= 0) && (!resetSelected)) {
          optionProp.editable = true
        }
      }

      return menuItems
    },
    /**
     * Handle Option property on click
     * @param {String} propertyId -  selected property id
     */
    handlePropertyClick (propertyId) {
      const editableOptionProperties = this.editableOptionProperties

      if (editableOptionProperties.indexOf(propertyId) < 0) editableOptionProperties.push(propertyId)

      this.editableOptionProperties = editableOptionProperties
      this.menuItems = this.filterOptionProperties(this.menuItems, false)

      if (propertyId === 'name') {
        this.$nextTick(_ => {
          this.$refs.playListInputName[0].select()
        })
      }
    },

    handleInputNameEnter () {
      this.$refs.playListInputName[0].blur()
    }
  },
  mounted () {
    this.setDefaultData(this.projectTemplateProp)
  }
}
